import HBButton from "@/components/HBButton";
import HBIcon from "@/components/HBIcon";
import { checkAiContentDisclaimer } from "@/utils/gdEdit";
import { huabanArtHost } from "@/utils/host";
import imageUrl from "@/utils/imageUrl";
import { openBindTelModal } from "@/utils/open";
import { Tooltip } from "antd";
import QueryString from "qs";
import React, { useCallback } from "react";
import styles from "./index.module.less";

function WrapWithCondition<P>(Comp: React.ComponentType<P>) {
  return function WrappedComp({
    condition,
    children,
    ...props
  }: P & {
    condition: boolean;
    children: React.ReactNode;
  }) {
    if (!condition) {
      return <>{children}</>;
    }
    return <Comp {...(props as any)}>{children}</Comp>;
  };
}

const TooltipWithCondition = WrapWithCondition(Tooltip);

export default function NormalButton({
  pin,
  searchWord,
}: {
  pin: IPin;
  searchWord?: string;
}) {
  const shouldShowAiTools = !(pin?.domain?.copyright_domain || !pin?.file);

  const goAi = useCallback(async () => {
    await openBindTelModal();

    if (!(await checkAiContentDisclaimer())) {
      return;
    }

    const query = {
      action_extension: "ai",
      action_extension_params: JSON.stringify({
        command: "openImageInspiration",
      }),
      mode: "open_remote_file",
      resource_url: imageUrl(pin.file, { origin: true }),
      resource_from: "huaban",
    };
    window.open(
      `${
        location.protocol
      }//${huabanArtHost}/editor/canvas?${QueryString.stringify(query)}`,
      "_blank"
    );
  }, [pin]);

  return (
    <div className={styles.btns}>
      {pin?.source && !pin?.domain?.hide_origin && (
        <HBButton
          theme="gray"
          title={pin?.link}
          target="_blank"
          href={`/go?pin_id=${pin?.pin_id}&url=${encodeURIComponent(
            pin?.source
          )}`}
          rel="nofollow"
          data-gd-click="button_click"
          data-module-name="采集详情"
          data-pin-detail
          data-button-name="访问网站"
          data-search-word={searchWord}
          bold
          icon={<HBIcon type="launch" />}
        >
          访问网站
        </HBButton>
      )}
      {shouldShowAiTools && (
        <TooltipWithCondition
          condition={false}
          title={
            <>
              不得侵犯他人合法权益，详见
              <br />
              <a
                href="https://huaban.com/about/disclaimer?activeKey=0"
                target="_blank"
                className={styles.tooltipLink}
              >
                《用户协议》
              </a>
              第十一条第二款
            </>
          }
          placement="bottom"
        >
          <HBButton
            className={styles.editBtn}
            data-gd-click="button_click"
            data-button-name="开个脑洞"
            data-pin-detail
            data-search-word={searchWord}
            onClick={goAi}
            theme="gray"
            icon={<HBIcon type="edit_new" />}
          >
            编辑
          </HBButton>
        </TooltipWithCondition>
      )}
    </div>
  );
}
